import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from "@angular/common";


@Pipe({ name: 'dateTimeFormatter', pure: true })
export class DateTimeFormatterPipe extends DatePipe implements PipeTransform {

  transform(value: any, pattern: string = "dateFormatter"): string | null {
    pattern = 'y-MM-dd hh:mm a';
    let result = super.transform(value, pattern);
    return result;
  }

  map = {
    "Asia/Calcutta": "IST"
  };

}




